import { IExperiments } from '../../../../../../../../../../../types/reducers/experiments';
import { servicesCardsTextsExperimentName, TExperiments } from '../../../../../../../../../../../constants/experiments';
import { IGetTexts } from './getServiceText';

export const topServiceControlGroup: IGetTexts = {
  title: 'Топ',
  subtitle: 'Максимум звонков',
  description: ['Быстрее результат', '4 фото и яркий заголовок', 'Выше всех в начале поиска'],
};

export const topServiceBGroup: IGetTexts = {
  title: 'Топ',
  subtitle: 'До х8 просмотров',
  description: ['Быстрее результат', '4 фото и яркий заголовок', 'Выше всех в начале поиска'],
};

export const topServiceCGroup: IGetTexts = {
  title: 'Топ',
  subtitle: 'До х8 показов',
  description: ['Быстрее результат', '4 фото и яркий заголовок', 'Выше всех в начале поиска'],
};

export const getTopTexts = (experiments: IExperiments, allExperiments: TExperiments): IGetTexts => {
  if (experiments[servicesCardsTextsExperimentName]) {
    const groups = allExperiments[servicesCardsTextsExperimentName];

    switch (experiments[servicesCardsTextsExperimentName]) {
      case groups?.default: {
        return topServiceControlGroup;
      }
      case groups?.shows: {
        return topServiceCGroup;
      }
      case groups?.views: {
        return topServiceBGroup;
      }
    }
  }

  return topServiceControlGroup;
};
